module.exports = __webpack_public_path__ + "static/google-play-badge-22c878482f126c8a093d3142c111e401.png";